import { defineComponent as _defineComponent } from 'vue'
import { queries } from "@/apollo";
import { Release, User, AppMode } from "@/CodegenTypes";
import { customMoment } from "@/main";
import { first, startCase, sumBy } from "lodash";
import { formatCount } from "@/helpers/formatCount";
import { formatDollar } from "@/helpers/formatDollar";
import { canSeeDdCompanyLevel } from "@/helpers/user/canSeeDdCompanyLevel";
import { computed, reactive } from "vue";
import { useQuery } from "@vue/apollo-composable";
import { useRoute } from "vue-router/composables";
import { useTranslation } from "@/store/translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'StrikeReport',
  setup(__props) {

const route = useRoute()
const { $t } = useTranslation();


const selectedStartReleaseDate = computed(() => {
  const query = route.query.startReleaseDate;
  return Array.isArray(query) ? first(query) : query;
})


const selectedEndReleaseDate = computed(() => {
  const query = route.query.endReleaseDate;
  return Array.isArray(query) ? first(query) : query;
})


const { result: meResult } = useQuery<{ me: User }>(queries.me, {}, { fetchPolicy: 'cache-first' })
const { result, loading } = useQuery<{ releases: Release[] }>(queries.releasesWithStrikeReports, { appMode: AppMode.Dd, dateRange: reactive({ releaseDateStart: selectedStartReleaseDate, releaseDateEnd: selectedEndReleaseDate }) })


const seeCompanyLevel = computed(() => {
  return canSeeDdCompanyLevel(meResult.value?.me);
})



const reversedReleases = computed(() => {
  const releases = result.value?.releases;
  if (!releases) return [];
  return [...releases].reverse();
})


const processedStrikeReports = computed(() => {


  const processed = reversedReleases.value.map((release) => {
    const reportRows = release.strikeSummaryReports;
    let firstStarter = true;
    let firstConsolation = true;

    const summary = {
      companyBig: sumBy(reportRows, (row) => row.companyBig),
      companySmall: sumBy(reportRows, (row) => row.companySmall),
      companyAmount: sumBy(reportRows, (row) => row.companyAmount),
      outAmount: sumBy(reportRows, (row) => row.outsetAmount),
    };

    return {
      releaseDate: release.releaseDate,
      rows: reportRows.map((row) => {
        let prizeName = startCase(row.strikeType);
        let rowSpan = 1;
        if (row.strikeType.includes("starter")) {
          if (firstStarter) {
            prizeName = "Starter";
            rowSpan = 10;
            firstStarter = false;
          } else {
            prizeName = "";
          }
        }
        if (row.strikeType.includes("consolation")) {
          if (firstConsolation) {
            prizeName = "Consolation";
            rowSpan = 10;
            firstConsolation = false;
          } else {
            prizeName = "";
          }
        }
        return {
          ...row,
          prizeName,
          rowSpan,
        };
      }),
      summary,
    };
  });

  return processed;
})

function formatDate(date: string) {
  return customMoment(date).format("DD MMM YYYY");
}

function formatDatetime(date: string) {
  return customMoment(date).format("DD/MMM HH:mm:ss");
}


return { __sfc: true,route, $t, selectedStartReleaseDate, selectedEndReleaseDate, meResult, result, loading, seeCompanyLevel, reversedReleases, processedStrikeReports, formatDate, formatDatetime, startCase, formatCount, formatDollar }
}

})